import { AxiosRequestConfig } from 'axios';

import { AUTH_TYPE, getAccessToken, getAuthType } from '../auth';

function isPathExcluded(url: string) {
  return url.endsWith('/partner/v1/partners/gobiz/oauth2/token');
}

/**
 * Include access token for all requests that don't have it yet
 *
 */
function addAuthorizationHeaderIfNotExists(config: AxiosRequestConfig) {
  if (!config.headers.Authorization && !isPathExcluded(config.url as string)) {
    const accessToken: string = getAccessToken();
    let header = accessToken;
    if (getAuthType() === AUTH_TYPE.GO_AUTH) {
      header = `Bearer ${accessToken}`;
    }

    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = header;
  }
  return config;
}

export default addAuthorizationHeaderIfNotExists;
